import React, { Component } from 'react';
import { SVGIcon } from '@custom-components';
import PropTypes from 'prop-types';
import { DialogActions, Divider } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import { PortalButton } from '../../BuildingBlocks/PortalButton/PortalButton';

import {
  StyledDialog,
  StyledDialogContent,
  StyledCloseButtonWrapper,
  StyledHeader,
  StyledTitle,
  StyledSubTitle
} from './Modal.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

const styles = () => ({
  paper: {
    boxShadow: 'none',
    borderRadius: 0
  },
  paperNoOverflow: {
    boxShadow: 'none',
    borderRadius: 0,
    overflow: 'visible'
  }
});

class Modal extends Component {
  getActions = () => {
    const { actions } = this.props;
    return actions.map((action, index) => {
      const key = `button${index}`;
      return <PortalButton key={key} {...action} />;
    });
  };

  getHeader = () => {
    const { handleClose, closeButton, showClose, title, fullContent, subtitle } = this.props;
    const close = (
      <StyledCloseButtonWrapper className="modal-close" onClick={handleClose}>
        {closeButton}
      </StyledCloseButtonWrapper>
    );

    return (
      <StyledHeader fullContent={fullContent}>
        <StyledTitle>{title} </StyledTitle>
        {showClose && close}
        <StyledSubTitle>{subtitle}</StyledSubTitle>
      </StyledHeader>
    );
  };

  render() {
    const {
      classes,
      noOverflow,
      openModal,
      content,
      handleClose,
      actions,
      fullContent,
      smallModal,
      disableEnforceFocus,
      children,
      maxWidth,
      titleDivider
    } = this.props;

    let dialogClassNames = '';
    if (fullContent) dialogClassNames += 'fullContent ';
    if (noOverflow) dialogClassNames += 'noOverflow ';

    return (
      <StyledDialog
        classes={{ paper: noOverflow ? classes.paperNoOverflow : classes.paper }}
        open={openModal}
        onClose={handleClose}
        maxWidth={maxWidth}
        smallmodal={smallModal.toString()}
        // noOverflow={noOverflow}
        className={dialogClassNames}
        disableEnforceFocus={disableEnforceFocus}
      >
        {this.getHeader()}
        {titleDivider && <Divider orientation="horizontal" variant="fullWidth" />}
        <StyledDialogContent className={dialogClassNames}>{content || children}</StyledDialogContent>
        {actions.length !== 0 && (
          <DialogActions style={{ padding: '0px 24px 24px' }}>{this.getActions()}</DialogActions>
        )}
      </StyledDialog>
    );
  }
}

Modal.propTypes = {
  openModal: PropTypes.bool,
  handleClose: PropTypes.func,
  content: ReactChildrenPropType,
  children: ReactChildrenPropType,
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      onClick: PropTypes.fun,
      btnTheme: PropTypes.string,
      disabled: PropTypes.bool,
      loading: PropTypes.bool,
      type: PropTypes.oneOf(['button', 'submit', 'reset', null])
    })
  ),
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  smallModal: PropTypes.bool,
  closeButton: PropTypes.node,
  showClose: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  subtitle: PropTypes.string,
  fullContent: PropTypes.bool,
  classes: PropTypes.shape({
    paperNoOverflow: PropTypes.string,
    paper: PropTypes.string
  }).isRequired,
  titleDivider: PropTypes.bool,
  noOverflow: PropTypes.bool,
  disableEnforceFocus: PropTypes.bool
};

Modal.defaultProps = {
  openModal: false,
  handleClose: () => {},
  content: null,
  children: null,
  actions: [],
  maxWidth: false,
  smallModal: false,
  closeButton: <SVGIcon selectedIcon="closeModal" />,
  showClose: true,
  title: '',
  subtitle: '',
  titleDivider: false,
  fullContent: false,
  noOverflow: false,
  disableEnforceFocus: false
};

const ComposedModal = withStyles(styles)(Modal);
export default ComposedModal;
